import classes from "./Loader.module.css";
import {CircularProgress} from "@mui/material";
import {React, useEffect} from "react";
import logo from "../../../store/logo.png"

const Loader = () => {

    useEffect(() => {
        const delay = 10 * 1 * 1000
        const refreshPage = setTimeout(() => {
            window.location.reload();
        },delay);
        return () => {
            clearTimeout(refreshPage);
        };
    }, []);

    return <div className={classes.cont}>
        <CircularProgress color="success" size={100}/>
        <div className={classes.logo}>
            <img src={logo} alt={"logo"}/>
        </div>
    </div>
}

export default Loader